export default {
  'menu.home': '首页',

  'menu.login': '登录',
  'menu.register': '注册',

  'menu.data-manage': '数据管理',
  'menu.data-manage.project-cost-price': '项目成本价格',
  'menu.data-manage.project-cost-price.project-info': '项目信息',
  'menu.data-manage.project-cost-price.approval-price-info': '项目报审价信息',
  'menu.data-manage.project-cost-price.occurred-cost-info': '已发生成本信息',

  'menu.data-manage.cost-price-basic': '成本价格基础数据',
  'menu.data-manage.cost-price-basic.basic-price': '基础价格',
  'menu.data-manage.cost-price-basic.basic-price.materials': '物资价格',
  'menu.data-manage.cost-price-basic.basic-price.services': '服务价格',

  'menu.data-manage.cost-price-basic.standard-cost': '标准成本',
  'menu.data-manage.cost-price-basic.standard-cost.production': '产品标准成本',
  'menu.data-manage.cost-price-basic.standard-cost.material-quota': '材料定额',
  'menu.data-manage.cost-price-basic.standard-cost.man-hour-quota': '工时定额',
  'menu.data-manage.cost-price-basic.standard-cost.power-quota': '动力定额',

  'menu.data-manage.price': '成本价格数据管理',
  'menu.data-manage.price.org': '组织经营成本',
  'menu.data-manage.price.project': '项目成本价格',
  'menu.data-manage.price.basic-data': '成本价格基础数据',

  'menu.data-manage.knowledge': '知识管理',

  'menu.cost-dashboard': '成本看板',
  'menu.cost-dashboard.project': '领域项目看板',
  'menu.cost-dashboard.designer': '设计师看板',

  'menu.model-manage': '模型管理',
  'menu.model-manage.project': '成本分解结构搭建与管理',
  'menu.model-manage.project.list': '项目列表',
  'menu.model-manage.project.work-stage': '工作阶段',
  'menu.model-manage.work-stage': '成本分解结构搭建与管理',
  'menu.model-manage.work-stage.project': '项目列表',
  'menu.model-manage.params': '参数化成本模型管理',
  'menu.model-manage.engineering': '成本分解结构管理',
   'menu.model-manage.baseline': '基线模型管理',

  'menu.lcc-estimation': 'LCC估算',
  'menu.lcc-estimation.list': '经济论证',
  'menu.lcc-estimation.manage': '管理',

  'menu.cost-design': '成本设计-可暂缓',
  'menu.fund-manage': '经费管理-可暂缓',

  'menu.system-manage': '系统管理',
  'menu.system-manage.basic-data': '基础数据管理',
  'menu.system-manage.user': '用户管理',
};
